import { inject, Injectable } from '@angular/core';
import { ROUTES } from '@core/constants';
import { IResponseHttp, VehicleHistoryPayload } from '@core/models';

import { ApiService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class VehicleHistoryService {
  readonly api = inject(ApiService);

  async getVehicleHistory(vehicleId: string): Promise<VehicleHistoryPayload> {
    const result = await this.api.get<IResponseHttp>(
      ROUTES.ADMIN_GET_HISTORY_VEHICLE(vehicleId),
    );
    return result.payload;
  }
}
